/*
 * A count with a label. Deliberately not a chart: for a handful of independent
 * magnitudes with no shared scale and no time axis, a tile is the right form and
 * a bar chart would invent a comparison that does not exist.
 *
 * Numbers wear ink tokens, never a series colour.
 */

interface StatTileProps {
  label: string
  value: number | null
  hint?: string
}

export function StatTile({ label, value, hint }: StatTileProps) {
  return (
    <div className="rounded-lg border border-line bg-surface-raised p-4">
      <div className="text-xs font-medium tracking-wide text-ink-muted uppercase">{label}</div>
      <div className="mt-1 font-mono text-2xl font-semibold tabular-nums text-ink">
        {value === null ? '—' : value.toLocaleString()}
      </div>
      {hint ? <div className="mt-0.5 text-xs text-ink-muted">{hint}</div> : null}
    </div>
  )
}
